module.exports = __webpack_public_path__ + "static/st-martin-ab83ac98e901bfe7388349224d461d14.svg";